import React from 'react'
import Main from '../components/Main'
import Row from '../components/Row'
import requests from '../Requests'

const Home = () => {
  return (
    <>
        <Main />
        <Row rowID='1' title='UpComing' fetchURL={requests.requestUpComing} />
        <Row rowID='2' title='Popular' fetchURL={requests.requestPopular} />
        <Row rowID='3' title='Trending' fetchURL={requests.requestTrending} />
        <Row rowID='4' title='Top Rated' fetchURL={requests.requestTopRated} />
        <Row rowID='5' title='Up Coming' fetchURL={requests.requestUpComing}/>
        <p className='text-white/70 text-[14px] text-center md:mt-[100px] mt-[80px] md:mb-[40px] mb-[30px]'>Copyright © 2022 - Ifeanyi Umeh</p>
    </>
  )
}

export default Home